import { render, staticRenderFns } from "./ImportAuthors.vue?vue&type=template&id=64c08dc2&"
import script from "./ImportAuthors.vue?vue&type=script&lang=js&"
export * from "./ImportAuthors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VBtn,VFileInput})
